import { render, staticRenderFns } from "./_base-subtitle.vue?vue&type=template&id=30d26fe4&"
import script from "./_base-subtitle.vue?vue&type=script&lang=js&"
export * from "./_base-subtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/ARCHIVE/Source/five9/ps-droids/packages/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d26fe4')) {
      api.createRecord('30d26fe4', component.options)
    } else {
      api.reload('30d26fe4', component.options)
    }
    module.hot.accept("./_base-subtitle.vue?vue&type=template&id=30d26fe4&", function () {
      api.rerender('30d26fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/_base-subtitle.vue"
export default component.exports